export default __webpack_public_path__ + "static/Avatar-739ad6d0de35b73c6a74ec2ef53dac9a.png";